<app-background-animation></app-background-animation>
<div class="patient-survey-container">
    <div class="survey-stepper">
        <mat-card #scrollableParent>
            <ng-container *ngIf="surveyDetails; else loading">
                <mat-stepper [orientation]="(stepperOrientation | async)!" [linear]="isLinear" #stepper
                    *ngIf="!showCompleted" (selectionChange)="onStepChange($event)">

                    <mat-step>
                        <form>
                            <div class="welcome-message" id="step-0-content">
                                <h1>Welcome</h1>
                                <ng-container *ngIf="surveyDetails.surveyIntroduction">
                                    <p class="message">{{surveyDetails.surveyIntroduction}}</p>
                                </ng-container>
                                <ng-container *ngIf="!surveyDetails.surveyIntroduction">
                                    <p class="message">{{group.name}} values your feedback and strives to improve the
                                        quality of our care. Please take a few minutes to complete this survey.</p>
                                </ng-container>

                                <div class="contact-details">
                                    <p>
                                        <span *ngIf="group.practiceNumber">
                                            <strong>Practice Number: </strong>
                                            {{group.practiceNumber}}
                                        </span>

                                        <span *ngIf="group.practicePhone">
                                            <span *ngIf="group.practiceNumber"> | </span>
                                            <strong>Phone Number: </strong>
                                            <a href="tel:{{group.practicePhone}}">{{group.practicePhone}}</a>
                                        </span>

                                        <span *ngIf="group.practiceEmail">
                                            <span *ngIf="group.practiceNumber || group.practicePhone"> | </span>
                                            <strong>Email: </strong>
                                            <a href="mailto:{{group.practiceEmail}}">{{group.practiceEmail}}</a>
                                        </span>
                                    </p>
                                </div>

                                <div class="stepper-actions">
                                    <button mat-raised-button matStepperNext color="primary">Start Survey</button>
                                </div>
                            </div>
                        </form>
                    </mat-step>

                    <mat-step [stepControl]="surveyForm"
                        *ngFor="let section of surveySections; let sectionIndex = index">
                        <form [formGroup]="surveyForm">
                            <h1 class="tab-heading">{{section.title}}</h1>
                            <div class="form-container" [id]="'step-' + (sectionIndex + 1) + '-content'">
                                <div class="form-fields">
                                    <div *ngFor="let question of section.questions" class="question-container">
                                        <div class="question-text">
                                            <h3>{{question.question}}</h3>
                                            <span *ngIf="question.required" class="required-indicator">*</span>
                                        </div>

                                        <!-- Radio button questions -->
                                        <div *ngIf="question.type === 'radio'" class="radio-options">
                                            <mat-radio-group [formControlName]="question.id">
                                                <mat-radio-button *ngFor="let option of question.options"
                                                    [value]="option.value" class="radio-option">
                                                    {{option.text}}
                                                </mat-radio-button>
                                            </mat-radio-group>
                                            <mat-error
                                                *ngIf="surveyForm.get(question.id)?.hasError('required') && surveyForm.get(question.id)?.touched">
                                                This question is required.
                                            </mat-error>
                                        </div>

                                        <!-- Textarea questions -->
                                        <div *ngIf="question.type === 'textarea'" class="textarea-container">
                                            <mat-form-field appearance="outline" class="full-width">
                                                <textarea matInput [formControlName]="question.id"
                                                    [placeholder]="question.placeholder || ''" rows="4"
                                                    cdkTextareaAutosize>
                                                </textarea>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>

                                <div class="stepper-actions">
                                    <button mat-button matStepperPrevious *ngIf="sectionIndex > 0">Back</button>

                                    <!-- Next button that shows when section is completed -->
                                    <button mat-raised-button matStepperNext
                                        *ngIf="sectionIndex < surveySections.length - 1"
                                        [color]="isSectionCompleted(section) ? 'primary' : ''"
                                        [disabled]="!isSectionCompleted(section)">
                                        <mat-icon *ngIf="isSectionCompleted(section)"
                                            class="section-completed-icon">check</mat-icon>
                                        {{ isSectionCompleted(section) ? 'Section Complete - Next' : 'Complete Section
                                        to Continue' }}
                                    </button>

                                    <!-- Submit button for the last section -->
                                    <button mat-raised-button [color]="formIsValid() ? 'primary' : 'warn'"
                                        (click)="submit()" [disabled]="isLoading || !formIsValid()"
                                        *ngIf="sectionIndex === surveySections.length - 1">
                                        <mat-icon *ngIf="formIsValid()">send</mat-icon>
                                        {{ formIsValid() ? 'Submit Survey' : 'Complete All Required Questions' }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </mat-step>
                </mat-stepper>

                <div class="completed" *ngIf="showCompleted">
                    <div class="check-icon">
                        <svg width="150" height="150" viewBox="0 0 24 24">
                            <circle cx="12" cy="12" r="10" stroke="#009688" stroke-width="1" fill="transparent" />
                            <path fill="none" stroke="#009688" stroke-width="1" stroke-linecap="round"
                                stroke-linejoin="round" stroke-dasharray="22" stroke-dashoffset="22" d="M7 12l3 3 7-7"
                                class="check-mark"></path>
                        </svg>
                    </div>
                    <h1>Thank You</h1>
                    <p>Thank you for taking the time to provide your feedback.</p>
                    <p>Your responses have been securely stored and will help us improve our services.</p>
                    <p>You can now safely close this window.</p>
                </div>
            </ng-container>
        </mat-card>
    </div>
</div>

<ng-template #loading>
    <div class="loader" *ngIf="!errorText; else error;">
        <mat-spinner></mat-spinner>
        <p>Loading survey...</p>
    </div>
</ng-template>

<ng-template #error>
    <div class="error">
        <svg width="150" height="150" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" stroke="#D32F2F" stroke-width="1" fill="transparent"></circle>
            <path d="M12 8v6" stroke="#D32F2F" stroke-width="1" stroke-linecap="round" class="error-mark"></path>
            <circle cx="12" cy="17" fill="#D32F2F" r="1"></circle>
        </svg>
        <h2>An Error Has Occurred</h2>
        <p>{{ errorText }}</p>
    </div>
</ng-template>